import script from "./tiptapTextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./tiptapTextEditor.vue?vue&type=script&setup=true&lang=js"

import "./tiptapTextEditor.vue?vue&type=style&index=0&id=d1adb40e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1adb40e"]])

export default __exports__